import { createTelemetryObject, createTelemetry } from '@shared/core/analytics';

const category = 'website';
const pagePrefix = 'admin';
const action = 'TravelButtonInteracted';

const actionProps = {
  action,
  category,
  pagePrefix,
};

const telemObject = createTelemetryObject({
  actions: {
    whereMyGuestsAreStayingDialogShown: (page: string) => ({
      ...actionProps,
      page,
      action: 'FeatureDialogPopup',
      extraInfo: {
        name: 'WhereMyGuestsAreStayingFeatureDialogShown',
      },
    }),
    whereMyGuestsAreStayingDialogDismissed: (page: string) => ({
      ...actionProps,
      page,
      extraInfo: {
        name: 'WhereMyGuestsAreStayingFeatureDialogDismissed',
      },
    }),
    showEventConfirmedBookingsClicked: (page: string) => ({
      ...actionProps,
      page,
      extraInfo: {
        name: 'ShowEventConfirmedBookings',
      },
    }),
    showEventStaysClicked: (page: string) => ({
      ...actionProps,
      page,
      extraInfo: {
        name: 'ShowEventStays',
      },
    }),
    remindGuestsToBookClicked: () => ({
      ...actionProps,
      extraInfo: {
        name: 'remindGuestsToBookClicked',
      },
    }),
    remindOtherGuestsToBookClicked: () => ({
      ...actionProps,
      extraInfo: {
        name: 'remindOtherGuestsToBookClicked',
      },
    }),
    bookingsViewSwitched: (view: string) => ({
      ...actionProps,
      extraInfo: {
        name: 'bookingsViewSwitched',
        view,
      },
    }),
    bookingsFilterOpened: () => ({
      ...actionProps,
      extraInfo: {
        name: 'bookingsFilterOpened',
      },
    }),
    bookingsSortChanged: (sortKey: string) => ({
      ...actionProps,
      extraInfo: {
        name: 'bookingsSortChanged',
        sortKey,
      },
    }),
    // ─── Guest stays dashboard (flag `guestStaysDashboard`) ───────────────────────────────────
    guestStaysDashboardViewed: (counts: { joyStayCount: number; sharedStayCount: number; missingCount: number; universeCount: number }) => ({
      ...actionProps,
      extraInfo: {
        name: 'guestStaysDashboardViewed',
        ...counts,
      },
    }),
    guestStaysStatusTabChanged: (tab: string) => ({
      ...actionProps,
      extraInfo: {
        name: 'guestStaysStatusTabChanged',
        tab,
      },
    }),
    guestStaysViewChanged: (view: string) => ({
      ...actionProps,
      extraInfo: {
        name: 'guestStaysViewChanged',
        view,
      },
    }),
    // `lodgingCount` is what the list was showing when the map was opened. Compared against the
    // panel's own "N places aren't shown" note, it tells us how often stays lack a usable location.
    guestStaysMapPanelToggled: (isOpen: boolean, lodgingCount: number) => ({
      ...actionProps,
      extraInfo: {
        name: 'guestStaysMapPanelToggled',
        isOpen,
        lodgingCount,
      },
    }),
    // `source` distinguishes the header's bulk CTA from a Missing-tab row, which scopes the composer
    // to a single person.
    guestStaysRequestStayDetailsClicked: (source: 'header' | 'missingRow', recipientCount: number) => ({
      ...actionProps,
      extraInfo: {
        name: 'guestStaysRequestStayDetailsClicked',
        source,
        recipientCount,
      },
    }),
    guestStaysQueryError: (query: 'stays' | 'guests') => ({
      ...actionProps,
      extraInfo: {
        name: 'guestStaysQueryError',
        query,
      },
    }),

    // Cross-link out to RSVP Results: a booking-tracker guest row's "View RSVP Response" click.
    // `view` records which booking view (byLodging / byGuest) the click originated from.
    viewRsvpResponseClicked: (view: string) => ({
      ...actionProps,
      extraInfo: {
        name: 'viewRsvpResponseClicked',
        view,
      },
    }),
    viewPageClicked: (tourName: string, stepName: string) => ({
      action: 'ButtonInteracted',
      category: 'Tour',
      extraInfo: {
        name: 'viewPageClicked',
        tourName,
        stepName,
      },
    }),
    exploreMoreHotelsClicked: (tourName: string, stepName: string) => ({
      action: 'ButtonInteracted',
      category: 'Tour',
      extraInfo: {
        name: 'exploreMoreHotelsClicked',
        tourName,
        stepName,
      },
    }),
  },
});

const { TelemetryProvider: GuestHotelBookingsListTelemetryProvider, useTelemetry: useGuestHotelBookingsListTelemetry } = createTelemetry(telemObject);

export { GuestHotelBookingsListTelemetryProvider, useGuestHotelBookingsListTelemetry };
